import React, { useEffect, useRef } from "react";
// import { optimize } from "svgo";

// https://alistairshepherd.uk/writing/svg-generative-ridges/

function MountainDivider({ className,  roughness, height, flip, mountainBody }) {

  function useMountain() {
    const svgWrapperRef = useRef();
    useEffect(() => {
      const WIDTH = window.innerWidth;
      const HEIGHT = parseFloat(getComputedStyle(document.body).fontSize) * height;
      const ITERATIONS = WIDTH < 400 ? 6 : WIDTH < 1000 ? 7 : WIDTH < 1920 ? 7 : WIDTH < 2560 ? 8 : WIDTH < 3840 ? 9 : 10;
      const ROUGHNESS = roughness;
      // mountain divider
      const divider = function () {
        const segments = Math.pow(2, ITERATIONS);
        const points = line(
          WIDTH,
          displaceMap(HEIGHT, HEIGHT / 4, ROUGHNESS, segments)
        );
        const path = convertPath(WIDTH, HEIGHT, points);

        const polyline = convertPolyline(points);

        const maxHeight = getMaxHeight(points);
        const svg = genSvg(WIDTH, maxHeight, path, polyline);
        // const result = optimize(svg, {
        //   plugins: [
        //     {
        //       name: 'preset-default',
        //       params: {
        //         overrides: {
        //           removeHiddenElems: false,
        //           removeEmptyContainers: false,
        //           convertPathData: false,
        //           removeUselessDefs: false,
        //           cleanupAttrs: false,
        //           cleanupIds: false,
        //           removeViewBox: true
        //         },
        //       },
        //     },
        //   ],
        // });
        // return result.data;
        return svg;
      };


      // generate midpoint displacement points
      function displaceMap(height, displace, roughness, power) {
        const points = [];
        // set initial left point
        points[0] = height / 2 + Math.random() * displace * 2 - displace;
        // set initial right point
        points[power] = height / 2 + Math.random() * displace * 2 - displace;
        displace *= roughness;
        // increase number of segments to maximum
        for (let i = 1; i < power; i *= 2) {
          // for each segment, find centre point
          for (let j = power / i / 2; j < power; j += power / i) {
            points[j] = (points[j - power / i / 2] + points[j + power / i / 2]) / 2;
            points[j] += Math.random() * displace * 2 - displace;
          }
          // reduce random range
          displace *= roughness;
        }
        let pointsToZero = 0;
        let min = Math.min(...points);
        pointsToZero = points.map(n => n - min + 10);
        return pointsToZero;
        // return points
      }

      // format points in [x, y] array
      function line(width, points) {

        const sep = width / (points.length - 1);
        return points.map((val, i) => [i * sep, Math.round(val)]);
      }

      // convert points into SVG path
      function convertPath(width, height, points) {
        // add first M (move) command
        const first = points.shift();
        let path = `M ${first[0]} ${first[1]}`;
        // iterate through points adding L (line) commands to path
        points.forEach((val) => {
          path += ` L ${val[0]} ${val[1]}`;
        });
        // close path
        path += ` L ${width} ${height} L 0 ${height} Z`;
        return path;
      }

      const convertPolyline = (points) => {
        let polyline = "";
        points.forEach((val) => {
          polyline += `${val[0]},${val[1]} `;
        });
        return polyline;
      };

      const getMaxHeight = (points) => {
        let maxHeight = 0;
        // let minHeight = 0
        let heightArray = [];
        points.forEach((val) => {
          heightArray.push(val[1]);
        });
        maxHeight = Math.max(...heightArray);
        return maxHeight;
      };

      // generate SVG from path
      const genSvg = (width, height, path, polyline) => `
          <svg viewBox="0 0  ${width} ${height}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">

          ${mountainBody ? `<path 
          class="mountain-body"
          stroke-opacity="0%" 
          stroke-width="0.5" 
          stroke-linejoin="miter"  
          ${flip ? 'transform="scale(1, -1) translate(0, -100)"' : " "}
           
          d="${path}">
          </path>` : " "}
          
            <polyline
            class="mountain-ridge"
            ${flip ? 'transform="scale(1, -1) translate(0, -100)"' : " "}  
            stroke-width="0.5" 
            stroke-linejoin="miter" 
            fill="none"
            stroke="var(--stroke-color)"  
            points="${polyline}"
            />
            
         
          </svg>
          `;
      svgWrapperRef.current.innerHTML = divider();
    }, []);
    return {
      svgWrapperRef
    };
  }

  const { svgWrapperRef } = useMountain();
  return (
    <div className={className} ref={svgWrapperRef}></div>
  );
}

export default MountainDivider;
